import debug from 'debug';
import CloudApi from 'Minetilbud/Shared/Components/CloudApi/Search';
import SearchApi from "Global/Minetilbud/Shared/Components/api-management/search";
import DataStorage from 'Minetilbud/Shared/Design101/8-organisms/search/data/data-storage';
import Settings from 'Minetilbud/Shared/Design101/8-organisms/search/data/settings';

import Facets from '../utils/facets';

const log = debug('ProductPagesSearch:Data:Data');

class Data {
	/** datasets contain all fetched dataset */
	static all = [];
	static dataset = {};
	static reactions = {};

	constructor() {
		this.componentKey = 'search-reactions-key';
		this.cache = 3600000; // 60 minutes in ms

		this.dataStorage = new DataStorage({ componentKey: this.componentKey });
	}

	/**
	 * @returns {Promise} products dataset
	 */
	async get() {
		try {
			const facets = Facets.get({ categories: Settings.categories, productsPerPage: Settings.productsPerPage, searchWord: Settings.searchWord });
			const cloudapi = new CloudApi();
			const response = await cloudapi.productsByCategories(facets);
			const dataset = await response.json();

			dataset.adverts.forEach(advert => {
				Data.all.push(advert);
			})

			Data.dataset = dataset
			
			return dataset;
		} catch(error) {
			log('get() - error', error);
		}
	}

	async getSearchReactions() {
		try {
			const response = await Promise.any([
				this.searchReactionsFromApi(),
				this.searchReactionsFromStorage()
			]);
	
			Data.reactions = response;

			return Data.reactions;
		}
		catch (error) {
			log("getSearchReactions() - error", error);
		}
	}

	async searchReactionsFromApi() {
		const searchApi = new SearchApi();
		const response = await searchApi.getSearchReactions();

		const reactions = await response.json();
		
		const data = {
			reactions,
			expire: Date.now() + this.cache
		}
		this.dataStorage.save(data);

		log('searchReactionsFromApi()', data);

		return reactions;
	}

	async searchReactionsFromStorage() {
		const data = this.dataStorage.load();

		if (data.expire < Date.now()) {

			log('searchReactionsFromStorage() - expired');

			return Promise.reject();
		}

		if (data.expire === undefined || data.reactions.length === 0)
		{
			log('searchReactionsFromStorage - Storage undefined or empty');
			return Promise.reject();
		}

		log('searchReactionsFromStorage()', data);
		return data.reactions;
	}
}

export default Data;
